module.exports = __webpack_public_path__ + "img/jr2.db8f49af.png";